module.exports = __webpack_public_path__ + "img/JXZWSZ_logo_M.5f327172.png";